var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle2, _path35, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystalsSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 188,
    viewBox: "0 0 195 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94,
    r: 92,
    fill: "#2D3344",
    stroke: "#4ADE80",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.636 40.9919L150.551 39.7126C149.568 38.6843 148.205 38.1025 146.78 38.1025H119.198C117.773 38.1025 116.41 38.6843 115.427 39.7126V40.9919L122.552 52.6739H144.563L150.636 40.9919Z",
    fill: "url(#paint0_linear_362_13979)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.198 38.1025C117.773 38.1025 116.41 38.6843 115.427 39.7126V40.9919L119.008 46.8642L125.179 38.1025H119.198Z",
    fill: "url(#paint1_linear_362_13979)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.989 38.1025L123.077 52.6739L123.695 53.2739H141.902L142.901 52.6739L132.989 38.1025Z",
    fill: "url(#paint2_linear_362_13979)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.427 39.7129L105.525 50.0689C104.853 50.7714 104.479 51.7042 104.479 52.6743L105.134 53.2739H122.043L123.076 52.6743L115.427 39.7129Z",
    fill: "url(#paint3_linear_362_13979)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.917 52.6733L119.356 46.3696L115.427 39.7119L105.525 50.068C104.853 50.7704 104.479 51.7033 104.479 52.6733L105.134 53.2729H115.229L114.917 52.6733Z",
    fill: "url(#paint4_linear_362_13979)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 52.6733C161.5 51.7033 161.125 50.7704 160.453 50.068L150.551 39.7119L142.901 52.6733L143.662 53.2729H161L161.5 52.6733Z",
    fill: "url(#paint5_linear_362_13979)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.479 52.6738C104.479 53.7626 104.868 54.8159 105.578 55.6439L128.925 82.9012C129.941 84.0862 131.426 84.7685 132.989 84.7685C134.553 84.7685 136.038 84.0862 137.053 82.9012L160.401 55.6439C161.11 54.8156 161.5 53.7626 161.5 52.6738H104.479Z",
    fill: "url(#paint6_linear_362_13979)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.917 52.6738H104.479C104.479 53.7626 104.868 54.8159 105.578 55.6439L128.926 82.9012C129.615 83.7062 130.522 84.2783 131.522 84.5632L114.917 52.6738Z",
    fill: "url(#paint7_linear_362_13979)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.99 84.7688C133.491 84.7688 133.984 84.6978 134.457 84.5632L142.902 52.6738H123.077L131.522 84.5632C131.995 84.6978 132.488 84.7688 132.99 84.7688V84.7688Z",
    fill: "url(#paint8_linear_362_13979)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.215 65.8139L101.467 63.6223C99.2701 62.2869 96.6202 61.9067 94.1347 62.5703L46.0318 75.4134C43.546 76.0769 41.442 77.7263 40.21 79.9774L40.81 82.2087L58.715 99.2644L97.1023 89.0152L102.215 65.8139Z",
    fill: "url(#paint9_linear_362_13979)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0318 75.4138C43.546 76.0774 41.442 77.7268 40.21 79.9778L40.81 82.2092L49.8104 90.7825L56.4624 72.6289L46.0318 75.4138Z",
    fill: "url(#paint10_linear_362_13979)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0833 68.9922L59.6299 99.0203L60.9888 99.7787L92.7422 91.3008L94.2039 89.7894L70.0833 68.9922Z",
    fill: "url(#paint11_linear_362_13979)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2095 79.9766L27.7969 102.648C26.955 104.186 26.7392 105.987 27.1942 107.679L28.6182 108.42L58.1092 100.546L59.6297 99.019L40.2095 79.9766Z",
    fill: "url(#paint12_linear_362_13979)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3991 102.819L50.1849 89.7588L40.2095 79.9775L27.7969 102.649C26.955 104.187 26.7392 105.988 27.1942 107.68L28.6182 108.421L46.2252 103.72L45.3991 102.819Z",
    fill: "url(#paint13_linear_362_13979)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.639 81.1286C126.184 79.4368 125.093 77.9846 123.592 77.0723L101.466 63.6221L94.2031 89.7887L95.8107 90.4806L126.048 82.4073L126.639 81.1286Z",
    fill: "url(#paint14_linear_362_13979)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1934 107.68C27.7039 109.579 28.8777 111.234 30.5031 112.349L84.0049 149.014C86.331 150.608 89.2408 151.106 91.9674 150.378C94.6942 149.65 96.9642 147.769 98.1786 145.229L126.114 86.8209C126.963 85.0461 127.149 83.0279 126.638 81.1289L27.1934 107.68Z",
    fill: "url(#paint15_linear_362_13979)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3983 102.82L27.1934 107.681C27.7039 109.579 28.8777 111.235 30.5031 112.349L84.0049 149.014C85.5848 150.097 87.434 150.672 89.3124 150.704L45.3983 102.82Z",
    fill: "url(#paint16_linear_362_13979)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9686 150.378C92.8433 150.145 93.6703 149.791 94.4311 149.337L94.2039 89.7891L59.6299 99.0203L89.3134 150.703C90.2003 150.718 91.0937 150.612 91.9686 150.378Z",
    fill: "url(#paint17_linear_362_13979)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.887 42.7949L147.814 41.6953C146.969 40.8115 145.798 40.3115 144.573 40.3115H120.866C119.641 40.3115 118.47 40.8115 117.625 41.6953V42.7949L123.749 52.8354H142.667L147.887 42.7949Z",
    fill: "#C3DDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.866 40.3115C119.641 40.3115 118.47 40.8115 117.625 41.6953V42.7949L120.703 47.842L126.007 40.3115H120.866Z",
    fill: "#A4CCFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.72 40.3115L124.2 52.8354L124.731 53.3511H140.38L141.239 52.8354L132.72 40.3115Z",
    fill: "#DBEAFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.625 41.6953L109.114 50.5962C108.537 51.1999 108.215 52.0017 108.215 52.8354L108.778 53.3508H123.312L124.2 52.8354L117.625 41.6953Z",
    fill: "#DBEAFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.187 52.8354L121.002 47.4175L117.625 41.6953L109.114 50.5962C108.537 51.1999 108.215 52.0017 108.215 52.8354L108.778 53.3508H117.455L117.187 52.8354Z",
    fill: "#C3DDFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.223 52.8354C157.223 52.0017 156.901 51.1999 156.324 50.5962L147.813 41.6953L141.238 52.8354L141.892 53.3508H156.794L157.223 52.8354Z",
    fill: "#DBEAFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.215 52.8359C108.215 53.7717 108.55 54.677 109.16 55.3887L129.227 78.8159C130.099 79.8345 131.375 80.4209 132.719 80.4209C134.063 80.4209 135.34 79.8345 136.212 78.8159L156.279 55.3887C156.889 54.6768 157.224 53.7717 157.224 52.8359H108.215Z",
    fill: "#A4CCFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M117.187 52.8359H108.215C108.215 53.7717 108.55 54.677 109.16 55.3887L129.227 78.8159C129.819 79.5078 130.599 79.9995 131.458 80.2444L117.187 52.8359Z",
    fill: "#8BB3EA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.72 80.4211C133.151 80.4211 133.575 80.3601 133.981 80.2444L141.239 52.8359H124.2L131.458 80.2444C131.865 80.3601 132.289 80.4211 132.72 80.4211V80.4211Z",
    fill: "#C3DDFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7799 69.9765L99.1039 67.9961C97.1188 66.7893 94.7243 66.4458 92.4783 67.0454L49.0099 78.6511C46.7637 79.2507 44.8624 80.7412 43.749 82.7754L44.2912 84.7917L60.4712 100.204L95.1599 90.9424L99.7799 69.9765Z",
    fill: "#C3DDFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0099 78.6514C46.7637 79.251 44.8624 80.7415 43.749 82.7756L44.2912 84.792L52.4245 92.5393L58.4356 76.1348L49.0099 78.6514Z",
    fill: "#A4CCFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7441 72.8486L61.2979 99.9836L62.5259 100.669L91.2198 93.0078L92.5407 91.6421L70.7441 72.8486Z",
    fill: "#DBEAFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7485 82.7754L32.5318 103.263C31.771 104.652 31.576 106.28 31.9871 107.809L33.2739 108.478L59.9235 101.363L61.2976 99.9832L43.7485 82.7754Z",
    fill: "#DBEAFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48.438 103.417L52.7628 91.6143L43.7485 82.7754L32.5318 103.263C31.771 104.652 31.576 106.28 31.9871 107.809L33.2739 108.478L49.1846 104.23L48.438 103.417Z",
    fill: "#C3DDFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.851 83.8159C121.439 82.2871 120.454 80.9749 119.098 80.1504L99.1032 67.9961L92.54 91.6416L93.9927 92.2668L121.317 84.9714L121.851 83.8159Z",
    fill: "#DBEAFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9863 107.809C32.4477 109.524 33.5084 111.02 34.9772 112.027L83.3242 145.16C85.4262 146.6 88.0557 147.051 90.5195 146.393C92.9836 145.735 95.0349 144.035 96.1323 141.74L121.376 88.959C122.144 87.3552 122.311 85.5315 121.85 83.8154L31.9863 107.809Z",
    fill: "#A4CCFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4373 103.417L31.9863 107.809C32.4477 109.525 33.5084 111.021 34.9772 112.028L83.3242 145.16C84.7519 146.138 86.4229 146.659 88.1203 146.687L48.4373 103.417Z",
    fill: "#8BB3EA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5208 146.393C91.3112 146.182 92.0585 145.863 92.746 145.452L92.5407 91.6416L61.2979 99.9834L88.1214 146.687C88.9229 146.7 89.7302 146.604 90.5208 146.393Z",
    fill: "#C3DDFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 156,
    r: 26,
    fill: "#4ADE80",
    stroke: "#2D3344",
    strokeWidth: 4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 163.172L155.914 156.586L153.086 159.414L162.5 168.828L181.914 149.414L179.086 146.586L162.5 163.172Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_362_13979",
    x1: 133.031,
    y1: 38.1025,
    x2: 133.031,
    y2: 52.6739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_362_13979",
    x1: 120.303,
    y1: 38.1025,
    x2: 120.303,
    y2: 46.8642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_362_13979",
    x1: 132.989,
    y1: 38.1025,
    x2: 132.989,
    y2: 53.2739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_362_13979",
    x1: 113.777,
    y1: 39.7129,
    x2: 113.777,
    y2: 53.2739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_362_13979",
    x1: 111.917,
    y1: 39.7119,
    x2: 111.917,
    y2: 53.2729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_362_13979",
    x1: 152.2,
    y1: 39.7119,
    x2: 152.2,
    y2: 53.2729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_362_13979",
    x1: 132.989,
    y1: 52.6738,
    x2: 132.989,
    y2: 84.7685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_362_13979",
    x1: 118,
    y1: 52.6738,
    x2: 118,
    y2: 84.5632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_362_13979",
    x1: 132.989,
    y1: 52.6738,
    x2: 132.989,
    y2: 84.7688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_362_13979",
    x1: 71.2124,
    y1: 62.251,
    x2: 71.2124,
    y2: 99.2644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_362_13979",
    x1: 48.3362,
    y1: 72.6289,
    x2: 48.3362,
    y2: 90.7825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_362_13979",
    x1: 76.9169,
    y1: 68.9922,
    x2: 76.9169,
    y2: 99.7787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_362_13979",
    x1: 43.2953,
    y1: 79.9766,
    x2: 43.2953,
    y2: 108.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_362_13979",
    x1: 38.5729,
    y1: 79.9775,
    x2: 38.5729,
    y2: 108.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_362_13979",
    x1: 110.421,
    y1: 63.6221,
    x2: 110.421,
    y2: 90.4806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_362_13979",
    x1: 77.0571,
    y1: 81.1289,
    x2: 77.0571,
    y2: 150.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_362_13979",
    x1: 58.2529,
    y1: 102.82,
    x2: 58.2529,
    y2: 150.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_362_13979",
    x1: 77.0305,
    y1: 89.7891,
    x2: 77.0305,
    y2: 150.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalsSuccess);
export default __webpack_public_path__ + "static/media/crystals_success.40600ffeac907b579a5f684fc89cb3a5.svg";
export { ForwardRef as ReactComponent };